import { render } from "./Contacts.vue?vue&type=template&id=655fdc6a&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=ts"
export * from "./Contacts.vue?vue&type=script&lang=ts"

import "./Contacts.vue?vue&type=style&index=0&id=655fdc6a&scoped=true&lang=css"
import "./Contacts.vue?vue&type=style&index=1&id=655fdc6a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-655fdc6a"

export default script